import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import moment from "moment";
import { Notificar } from "../../Comunes/Notificador";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import es from "date-fns/locale/es"; // the locale you want

registerLocale("es", es);

function ModificarPeriodoModal({ Operacion, actualizarPeriodoInicio }) {
    const [show, setShow] = useState(false);
    const [OperacionLocal, setOperacionLocal] = useState(Operacion);


    const handleClose = () => {
        setOperacionLocal(Operacion);
        setShow(false);
    };

    const handleShow = () => setShow(true);

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!datosValidos()) {
            return;
        }

        actualizarPeriodoInicio(OperacionLocal);
        handleClose();
    };

    function datosValidos() {
        if (
            new Date(OperacionLocal.periodoInicio) >
            new Date(OperacionLocal.periodoFin)
        ) {
            Notificar("error", "El periodo inicial no puede ser mayor al periodo final.");
            return false;
        } else if (new Date(OperacionLocal.periodoInicio) < new Date(OperacionLocal.periodoInicioReportado)
        ) {
            Notificar("error", `El periodo inicial no puede ser menor al periodo inicio ${moment(OperacionLocal.periodoInicioReportado).format("DD/MM/YYYY")} reportado por la SUGEF.`);
            return false;
        }
        return true;
    }

    return (
        <>
            <button
                className="btn btn-outline-primary btn-xs"
                title="Modificar Periodo Inicio"
                onClick={handleShow}
            >
                <i className="fas fa-edit"></i>
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Modificar Periodo Inicio</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleSubmit}>
                    <Modal.Body>


                        <div className="form-group">
                            <label htmlFor="FechaPeriodo">Periodo Inicio</label>
                            <DatePicker
                                id="FechaPeriodo"
                                locale="es"
                                selected={
                                    OperacionLocal.periodoInicio
                                        ? new Date(OperacionLocal.periodoInicio)
                                        : null
                                }
                                onChange={(fecha) =>
                                    setOperacionLocal({
                                        ...OperacionLocal,
                                        periodoInicio: moment(fecha).isValid()
                                            ? moment(fecha).format("YYYY-MM-DDTHH:mm:ss")
                                            : null,
                                    })
                                }
                                name="FechaPeriodo"
                                dateFormat="MM/yyyy"
                                className="form-control"
                                wrapperClassName="w-100"
                                showMonthYearPicker
                                showFullMonthYearPicker
                                openToDate={
                                    !OperacionLocal.periodoInicio
                                        ? new Date(OperacionLocal.periodoInicio)
                                        : null
                                }
                                maxDate={moment(new Date()).subtract(1, "days").toDate()}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancelar
                        </Button>
                        <Button variant="primary" type="submit">
                            Confirmar
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    );
}

export default ModificarPeriodoModal;
